// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 14L18.6 10.7L19.8 9.1L20.7282 9.79616C19.7453 5.891 16.2102 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C15.689 21 18.8618 18.7803 20.2516 15.5996L20.6519 14.6833L22.4846 15.484L22.0843 16.4004C20.3878 20.2833 16.5123 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12V14ZM16.8028 12L9.5 16.8685V7.13148L16.8028 12Z"}}]};

const ReplayFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'replay-filled',
    ref,
    icon: element,
  },
));

ReplayFilledIcon.displayName = 'ReplayFilledIcon';

export default ReplayFilledIcon;
